<ion-header id="pwa-install-header" *ngIf="showPwaInstallBanner">
	<ion-toolbar color="tertiary">
		<ion-buttons slot="end">
			<ion-button fill="solid" (click)="addToHomeScreen()">
				INSTALL
			</ion-button>
		</ion-buttons>

		<ion-title>
			MTPro Install
			<ion-text>Please install this app on your device</ion-text>
		</ion-title>
	</ion-toolbar>
</ion-header>
<ion-app [ngClass]="{ 'pwa-install': showPwaInstallBanner }">
	<ion-router-outlet></ion-router-outlet>
</ion-app>
